/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const CasesAPI = {
  getCases: async() =>
    (await initAxios())
      ?.get('/cases')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  searchCases: async(query: any) =>
    (await initAxios())
      ?.post('/cases/search', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  countCases: async(query: any) =>
    (await initAxios())
      ?.post('/cases/count', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getCase: async(case_id: string) =>
    (await initAxios())
      ?.get(`/cases/${case_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  // Mark a Tariff ticket's pending scheduled-check change as reviewed. A 409
  // means it was already reviewed or a newer change replaced it.
  reviewTariffChange: async(case_id: string, changeId: string) =>
    (await initAxios())
      ?.post(`/cases/${case_id}/tariff-change/review`, JSON.stringify({ changeId: changeId }))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          status: err?.response?.status as number | undefined,
          result: parseErrorMsg(err),
        };
      }),

  updateCase: async(caseBody: any) =>
    (await initAxios())
      ?.put('/cases', JSON.stringify(caseBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createCase: async(caseBody: any) =>
    (await initAxios())
      ?.post('/cases', JSON.stringify(caseBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteCase: async(case_id: string) =>
    (await initAxios())
      ?.delete(`/cases/${case_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default CasesAPI;
